
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CustomBtn from "@/components/CustomBtn.vue";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";
import { CUSTOMER_SUCCESS_TYPE } from "@/utils/customerSuccess";

@Component({
    components: { CustomBtn, MylobyAutocomplete },
})
export default class CustomerSuccessAddCompanyModal extends Vue {

    @Prop({ default: null })
    public userId: number;

    private dialogModel: boolean = true;
    private selectedCompany: any = null;
    private selectedType: string = null;

    get typeItems(): Array<{ text: string, value: string }> {
        return Object.values(CUSTOMER_SUCCESS_TYPE).map((type) => ({
            text: this.$t(`customerSuccess.type.${type}`).toString(),
            value: type,
        }));
    }

    @Watch("dialogModel")
    public handlerDialogModel(val: boolean) {
        if (!val) {
            this.$emit("close");
        }
    }

    private addCompany() {
        if (!this.selectedCompany || !this.selectedType) {
            return;
        }
        this.$store.dispatch("admin/customerSuccess/addCompany", {
            userId: this.userId,
            companyId: this.selectedCompany.id,
            type: this.selectedType,
        }).then(() => {
            this.$emit("added");
            this.$emit("close");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.$wait.end("customerSuccess/add-company");
        });
    }
}
